<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section flex">
              <h2 class="form-title" style="width: 400px;">
                Confirm Eligibility for the “Self-Rated” Program
              </h2>
              <p style="max-width: 350px; z-index: 1;" class="mx-4">
                For you to be eligible for E&O self-rating, the responses to questions 1-4 below must all be “TRUE”. If you answer “FALSE” to any of these questions, please call <strong>OREP</strong> to obtain our Standard Appraisers’ E&O Application.
              </p>
              <img
                src="../../../public/assets/images/pillar.png"
                class="title-section-img form-title-img risk-mgt-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="d-flex w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">1.</span>
                      The applicant holds a valid state license or certification in each state in which he/she provides appraisal services.  If you are a Trainee, you have passed the initial exam (if required) or any other state requirements.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="isTrainee"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.isTrainee"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="isTrainee"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.isTrainee"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('isTrainee')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('isTrainee') | filterText }}</span>
                  </div>
                </div>
              </div>
              <p v-show="individualAppraiser.isTrainee === false" class="text-danger text-center mt-4">
                Please stop and call OREP at 888-347-5273 for an alternative application.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">2.</span>
                      The applicant does not appraise any real estate in which he/she has an ownership interest.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="doNotAppraiseAnyRealEstate"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.doNotAppraiseAnyRealEstate"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="doNotAppraiseAnyRealEstate"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.doNotAppraiseAnyRealEstate"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('doNotAppraiseAnyRealEstate')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('doNotAppraiseAnyRealEstate') | filterText }}</span>
                  </div>
                </div>
              </div>
              <p v-show="individualAppraiser.doNotAppraiseAnyRealEstate === false" class="text-danger text-center mt-4">
                Please stop and call OREP at 888-347-5273 for an alternative application.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">3.</span>
                      The applicant has not been disciplined or investigated by any state licensing, administrative or regulatory board as a result of appraisal activities within the past 5 years.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="notDisciplinedByAnyState"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.notDisciplinedByAnyState"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="notDisciplinedByAnyState"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.notDisciplinedByAnyState"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('notDisciplinedByAnyState')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('notDisciplinedByAnyState') | filterText }}</span>
                  </div>
                </div>
              </div>
              <p v-show="individualAppraiser.notDisciplinedByAnyState === false" class="text-danger text-center mt-4">
                Please stop and call OREP at 888-347-5273 for an alternative application.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">4.</span>
                      There have been no claims reported and/or pending circumstances which could result in a claim made against the applicant within the past 5 years.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="noClaimsReported"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.noClaimsReported"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="noClaimsReported"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.noClaimsReported"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('noClaimsReported')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('noClaimsReported') | filterText }}</span>
                  </div>
                </div>
              </div>
              <p v-show="individualAppraiser.noClaimsReported === false" class="text-danger text-center mt-4">
                Please stop and call OREP at 888-347-5273 for an alternative application.
              </p>
            </article>

            <article class="form-heading title-section form-section d-flex" style="height: 145px;">
              <h2 class="form-title">
                Residential vs. Commercial Premiums
              </h2>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">5.</span>
                      In the last fiscal year, 80% or more of my revenues have been derived from residential appraisals.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="revenueIsDerivedFromResidentialAppraisals"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.revenueIsDerivedFromResidentialAppraisals"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="revenueIsDerivedFromResidentialAppraisals"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.revenueIsDerivedFromResidentialAppraisals"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('revenueIsDerivedFromResidentialAppraisals')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('revenueIsDerivedFromResidentialAppraisals') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">6.</span>
                      Within the last fiscal year, I have not appraised any properties valued at greater than $3,000,000.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="notAppraisedAnyProperties"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.notAppraisedAnyProperties"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="notAppraisedAnyProperties"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.notAppraisedAnyProperties"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('notAppraisedAnyProperties')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('notAppraisedAnyProperties') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">7.</span>
                      The applicant’s combined total gross revenues for the last three (3) years did not exceed $500,000.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="totalGrossRevenueNotExceed"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.totalGrossRevenueNotExceed"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="totalGrossRevenueNotExceed"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.totalGrossRevenueNotExceed"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('totalGrossRevenueNotExceed')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('totalGrossRevenueNotExceed') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">8.</span>
                      The applicant is not currently, and has not during the last five (5) years, operated under any chapter of the United States bankruptcy code.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="usBankRuptcyCodeStatus"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.usBankRuptcyCodeStatus"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="usBankRuptcyCodeStatus"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.usBankRuptcyCodeStatus"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('usBankRuptcyCodeStatus')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('usBankRuptcyCodeStatus') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">9.</span>
                      The applicant does not have similar insurance which is in the process of being cancelled or non-renewed.
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="insuranceAppStatus"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.insuranceAppStatus"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="insuranceAppStatus"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="individualAppraiser.insuranceAppStatus"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('insuranceAppStatus')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('insuranceAppStatus') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="d-flex flex-row align-items-center px-3">
                <label class="orep-label mb-0">
                  <span class="mr-2">10.</span>
                  Select Limits of Coverage:
                </label>
                <select
                  class="orep-select"
                  style="height: 60px; width: 383px;"
                  name="limitOfCoverage"
                  v-model="individualAppraiser.limitOfCoverage"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option value="0.3M/0.6M">$300,000 / $600,000</option>
                  <option value="0.5M/1M">$500,000 / $1,000,000</option>
                  <option value="1M/1M">$1,000,000 / $1,000,000</option>
                  <option value="1M/2M">$1,000,000 / $2,000,000</option>
                </select>
              </div>
              <span
                v-show="errors.has('limitOfCoverage')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('limitOfCoverage') | filterText }}</span>
              <label class="orep-label mt-3 ml-3">
                Many lenders/Financial Institutions require Minimum Aggregate Limit of $1,000,000.
              </label>
            </article>

          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'individual-appraiser-1'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button @click="prev()" class="pagination-dots"></button>
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid"
                @click="navigateToNext('individual-appraiser-3')">
              </button>
              <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
                @click="navigateToNext('individual-appraiser-4')">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageTwoIsValid"
                    :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('individual-appraiser-3')">Next</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Calculating premium...</span>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "individual-appraiser-2",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      individualAppraiser() {
        return this.$store.state.individualAppraiser.individualAppraiser;
      },
      state() {
        return this.$store.state.individualAppraiser;
      },
      errorMsg() {
        return this.$store.state.individualAppraiser.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              text: this.errorMsg,
              duration: 15000
            });
          }
        }
      }
    },
    methods: {
      prev() {
        this.$router.push({
          name: "individual-appraiser-1"
        });
      },

      navigateToNext(routeName) {
        this.getPremium(routeName);
      },

      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageTwoIsValid = true;
            return;
          }
          this.state.pageTwoIsValid = false;
        });
      },

      getPremium(routeName='individual-appraiser-3') {
        this.loading = true;
        this.$store.dispatch('individualAppraiser/getPremium', {routeName});
      }
    },

    mounted() {
      $("html, body").animate(
        {
          scrollTop: $(".page-content").offset().top
        },
        500
      );
    },

    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },
    components: {}
  };
</script>

<style scoped>
  .form-title {
    font-size: 35px !important;
  }
  .orep-label {
    margin-bottom: 10px;
  }
</style>

